import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';

function getInitial(name) {
  const n = (name || '').trim();
  return n ? n[0].toUpperCase() : '?';
}

function formatDate(dateString) {
  if (!dateString) return 'Recently';
  const date = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now - date);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

function RecentHires({ employees = [] }) {
  const recentEmployees = employees
    .slice(0, 5)
    .sort((a, b) => {
      // Sort by __isNew flag first (new employees first), then by id
      if (a.__isNew && !b.__isNew) return -1;
      if (!a.__isNew && b.__isNew) return 1;
      return b.id - a.id;
    });

  if (recentEmployees.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          Recent Hires
        </h3>
        <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-8">
          No recent hires to display
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm border border-gray-200 dark:border-gray-700">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        Recent Hires
      </h3>
      <div className="space-y-3">
        {recentEmployees.map((employee, index) => (
          <motion.div
            key={employee.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1, duration: 0.3 }}
            className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors cursor-pointer"
          >
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-bold text-sm shrink-0">
              {getInitial(employee.name)}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                {employee.name}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                {employee.company?.name || 'No company'}
              </p>
            </div>
            <div className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400 shrink-0">
              <Calendar size={12} />
              <span>{formatDate(employee.__isNew ? new Date() : null)}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default RecentHires;
